import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=38e80c8c&scoped=true"
import script from "./Documentation.vue?vue&type=script&lang=js"
export * from "./Documentation.vue?vue&type=script&lang=js"
import style0 from "./Documentation.vue?vue&type=style&index=0&id=38e80c8c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e80c8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e80c8c')) {
      api.createRecord('38e80c8c', component.options)
    } else {
      api.reload('38e80c8c', component.options)
    }
    module.hot.accept("./Documentation.vue?vue&type=template&id=38e80c8c&scoped=true", function () {
      api.rerender('38e80c8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Documentation.vue"
export default component.exports